/**
 * @param {string} permission
 * @param {object} user
 * @param {object} policies
 * @param {(user: object, additional: object, permission: string) => void} defaultHandler
 * @param {object} additional
 * @returns {boolean} - returns whether the user has the requested permission or not
 */
const gatesHandler = (permission, user, policies, defaultHandler, additional) => {
  if (!user) return false;
  if (policies && policies?.[permission]) {
    return policies[permission](user, additional);
  } else if (defaultHandler) {
    return defaultHandler(user, additional, permission);
  } else {
    return false;
  }
};

export default gatesHandler;
